module.exports = __webpack_public_path__ + "media/images/concepcion-carrier-industries-fde536dabe9e51e2abe06aff091c0099.png";